<template>
  <div class="details person">
    <div>
      <div class="name">
        {{ person.title }} {{ person.first_name }} {{ person.last_name }}
      </div>
      <div class="picture">
        <img
          v-if="person.picture_identifier"
          :src="'https://fileserver.documedias.systems/file/' + person.picture_identifier"
          style="width: 180px; height: 240px;" />
      </div>
      <table>
        <tbody>
          <tr v-if="person.institution">
            <td>{{ _.institution }}</td>
            <td>{{ person.institution }}</td>
          </tr>
          <tr v-if="person.department">
            <td>{{ _.department }}</td>
            <td>{{ person.department }}</td>
          </tr>
          <tr v-if="person.function">
            <td>{{ _.function }}</td>
            <td>{{ person.function }}</td>
          </tr>
          <tr v-if="person.street">
            <td>{{ _.street }}</td>
            <td>{{ person.street }}</td>
          </tr>
          <tr v-if="person.zip_code">
            <td>{{ _.zip_code }}</td>
            <td>{{ person.zip_code }}</td>
          </tr>
          <tr v-if="person.city">
            <td>{{ _.city }}</td>
            <td>{{ person.city }}</td>
          </tr>
          <tr v-if="person.country">
            <td>{{ _.country }}</td>
            <td>{{ _[person.country.iso_3166_alpha2] }}</td>
          </tr>
        </tbody>
      </table>
      <div v-if="person.biography" class="biography">
        <span v-html="person.biography"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from '@/config'
import { mapGetters } from 'vuex'
export default {
  props: ['id'],
  data() {
    return {
      person: {},
    }
  },
  computed: {
    ...mapGetters(['details']),
  },
  async created() {
    const persons = await this.axios.get(API_URL + '/persons/' + this.id + '/details');
    this.person = persons.data[0];
    this.setProgress(false);
  }
}
</script>

<style lang="scss">
.details.person {
  padding: 12px;
  > div {
    > .name {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 8px;
    }
    > .picture {
      padding: 0;
      margin-bottom: 8px;
    }
    > .biography {
      margin-top: 8px;
      margin-right: 12px;
    }
    > table {
      border: 0;
      border-collapse: collapse;
      border-spacing: 0;
      > tbody {
        > tr {
          &:first-child td {
            padding-top: 0;
          }
          > td {
            padding: 0 12px 0 0;
          }
          > td:first-child {
            width: 120px;
          }
        }
      }
    }
  }
}
</style>
